import { render, staticRenderFns } from "./ListProductPage.vue?vue&type=template&id=9bab2b68"
import script from "./ListProductPage.vue?vue&type=script&lang=js"
export * from "./ListProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports